<template>
    <div class="container">
        <div class="card-item">
            <div class="card-title">
                <p :class="sel == 0 ? 'active' : null" @click="tabToggle(0)">企业财税信息 <span v-if="moduleItemsList.includes('finance')" class="dotItem"></span></p>
                <p :class="sel == 1 ? 'active' : null" @click="tabToggle(1)">企业社保信息 <span v-if="moduleItemsList.includes('socialSecurity')" class="dotItem"></span></p>
            </div>
            <div class="card-content">
                <enterpriseFinance v-if="sel == 0"/>
                <enterpriseSecurity v-if="sel == 1"/>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import enterpriseFinance from './main-security-child/enterprise-finance-from'
    import enterpriseSecurity from './main-security-child/enterprise-security-from'
    export default {
        name: "main-security-form",
        components:{
            enterpriseFinance,
            enterpriseSecurity
        },
        data() {
            return {
                sel: 0,
            }
        },
        computed:{
            ...mapState({
                moduleItemsList:(state) => state.common.moduleItemsList,
            })
        },
        methods: {
            tabToggle (index) {
                this.sel = index;
            },
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-textarea__inner {
        width: 910px;
        height: 80px;
    }
    .container{
        .card-item{
            .card-title{
                cursor: pointer;
                display: flex;
                align-items: center;
                p{
                    position: relative;
                    font-size: 16px;
                    margin: 0 32px;
                    .dotItem{
                        position: absolute;
                        top: 14px;
                        right: -5px;
                        height: 6px;
                        width: 6px;
                        padding: 0;
                        border-radius: 50%;
                        background: #F56C6C;
                    }
                }
                .active{
                    color: #1890FF;
                    border-bottom: 2px solid #1890FF;
                    margin-bottom: 2px;
                }
            }
        }
    }
</style>